import React, { Component } from "react";
import { Button } from "react-bootstrap";

class InteractiveMessage extends Component {
    renderHeader() {
        const { msg } = this.props;
        const header = msg?.interactive_content?.header;
        if (!header) return null;

        if (header.type === "image") {
            return (
                <img
                    src={header.image?.link}
                    alt="Interactive Header"
                    style={{
                        width: "100%", height: "200px", objectFit: "contain",
                        borderRadius: 8, border: "1px solid var(--disabled-color)",
                    }}
                />
            );
        }
        if (header.type === "video") {
            return (
                <video
                    src={header.video?.link}
                    controls
                    style={{ maxWidth: "100%", borderRadius: 8, border: "1px solid var(--disabled-color)" }}
                />
            );
        }
        return null;
    }

    renderBody() {
        const { msg } = this.props;
        const body = msg?.interactive_content?.body?.text;
        if (!body) return null;
        return (
            <div className="mb-1">
                <small className="text-muted">
                    {body.replace(/\*([^*]+)\*/g, "⟨strong⟩$1⟨/strong⟩").split(/\\n/).map((line, idx) => (
                        <React.Fragment key={idx}>
                            {line.split(/⟨strong⟩|⟨\/strong⟩/).map((part, i) =>
                                i % 2 === 1 ? <strong key={i}>{part}</strong> : part
                            )}
                            <br />
                        </React.Fragment>
                    ))}
                </small>
            </div>
        );
    }

    renderButtons() {
        const { msg } = this.props;
        const buttons = msg?.interactive_content?.action?.buttons;
        if (!buttons) return null;
        return (
            <div className="mt-1">
                {buttons.map((btn) => (
                    <Button key={btn?.reply?.id} variant="primary" size="sm" className="w-100 mb-1">
                        {btn?.reply?.title}
                    </Button>
                ))}
            </div>
        );
    }

    renderList() {
        const { msg } = this.props;
        const { body, action } = msg?.interactive_content || {};
        return (
            <div className="mb-1">
                {body?.text && <small className="text-muted d-block mb-1">{body.text}</small>}
                {action && (
                    <Button variant="primary" size="sm" className="w-100">
                        <i className="fas fa-image mr-1" />{action.button}
                    </Button>
                )}
            </div>
        );
    }

    renderLocationRequest() {
        const { msg } = this.props;
        const action = msg?.interactive_content?.action;
        if (!action) return null;
        return (
            <div className="mb-1">
                <Button variant="primary" size="sm" className="w-100">
                    <i className="fas fa-comment-alt mr-1" />{action.name}
                </Button>
            </div>
        );
    }

    renderFinal() {
        const { msg } = this.props;
        const { body } = msg?.interactive_content || {};
        const linkify = (text) => {
            let formatted = text.replace(/\*([^*]+)\*/g, "⟨strong⟩$1⟨/strong⟩");
            formatted = formatted.replace(/(https?:\/\/[^\s]+)/g, (url) =>
                `<a href="${url}" target="_blank" rel="noopener noreferrer" style="color:#1976d2;text-decoration:underline;">${url}</a>`
            );
            return formatted;
        };
        return (
            <div className="mb-1">
                <small className="text-muted" style={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                    <span dangerouslySetInnerHTML={{ __html: linkify(body?.text || "") }} />
                </small>
            </div>
        );
    }

    render() {
        const { msg } = this.props;
        if (msg.media_type !== "interactive") return null;
        return (
            <div className="text-center">
                {msg?.interactive_content?.type === "button" && (
                    <div className="w-100 mb-2">
                        {this.renderHeader()}{this.renderBody()}{this.renderButtons()}
                    </div>
                )}
                {msg?.interactive_content?.type === "list" && (
                    <div className="w-100 mb-2">{this.renderList()}</div>
                )}
                {msg?.interactive_content?.type === "location_request_message" && (
                    <div className="w-100 mb-2">{this.renderLocationRequest()}</div>
                )}
                {msg?.interactive_content?.type === "final" && (
                    <div className="w-100 mb-2">{this.renderFinal()}</div>
                )}
            </div>
        );
    }
}

export default InteractiveMessage;
